module.exports = __webpack_public_path__ + "static/media/GH06.05a83960.png";